/** People, roles and permissions — English, the source of the other languages */
const users = {
  "users.removed": "User removed",
  "users.removeFailed": "The user could not be removed",
  "users.vpnUpdated": "VPN status updated",
  "users.vpnFailed": "The VPN could not be switched",
  "users.inviteSent": "Invite sent",
  "users.inviteSentAgain": "A new invite email has been sent.",
  "users.resendFailed": "The invite could not be sent again",
  "users.reset2faDone": "Two-factor sign-in reset",
  "users.reset2faText": "They are signed out everywhere and set it up again when they sign in.",
  "users.resetFailed": "Reset failed",
  "users.title": "Users",
  "users.count": { one: "{count} team member", other: "{count} team members" },
  "users.invite": "Invite user",
  "users.search": "Search users",
  "users.searchPlaceholder": "Search by name or email…",
  "users.user": "User",
  "users.role": "Role",
  "users.lastLogin": "Last sign-in",
  "users.empty": "No users found",
  "users.adminBadge": "Admin",
  "users.twoFactorOn": "Two-factor sign-in is on",
  "users.never": "Never",
  "users.resend": "Resend invite email",
  "users.suspendVpn": "Suspend VPN access",
  "users.enableVpn": "Turn VPN access back on",
  "users.suspendVpnConfirm": "Suspend the VPN of \"{name}\"?",
  "users.enableVpnConfirm": "Turn the VPN of \"{name}\" back on?",
  "users.reset2fa": "Reset two-factor sign-in",
  "users.reset2faFor": "Reset two-factor sign-in for {name}",
  "users.reset2faConfirm": "Reset two-factor sign-in for \"{name}\"? They are signed out everywhere and set it up again when they sign in.",
  "users.editAccess": "Edit access",
  "users.removeNamed": "Remove {name}",
  "users.removeConfirm": "Remove user \"{name}\"?",
  "users.updated": "User updated",
  "users.addedNoMail": "User added, but the invite email could not be sent",
  "users.addedNoMailText": "Check the mail settings, then use \"Resend invite email\".",
  "users.siteAccess": "Site access",
  "users.allSites": "All sites (including sites added later)",
  "users.noSites": "No sites yet",
  "users.noneSelected": "No sites selected — this user will not see any site.",
  "users.updateFailed": "The user could not be updated",
  "users.editTitle": "Edit {name}",
  "users.noRole": "No role",
  "users.noRoleCustom": "No role (own permissions)",
  "users.companyAdmin": "Company administrator (full access)",
  "users.save": "Save",
  "users.inviteFailed": "The user could not be invited",
  "users.inviteTitle": "Invite a team member",
  "users.fullName": "Full name *",
  "users.fullNamePlaceholder": "Jane Smith",
  "users.email": "Email address *",
  "users.emailPlaceholder": "jane@company.com",
  "users.inviteInfo": "An invite email is sent with a link to set a password. The VPN account is created automatically.",
  "users.sendInvite": "Send invite",
  "users.roles.deleted": "Role deleted",
  "users.roles.deleteFailed": "The role could not be deleted",
  "users.roles.title": "Roles",
  "users.roles.subtitle": "Sets of permissions for your team members",
  "users.roles.create": "Create role",
  "users.roles.system": "SYSTEM",
  "users.roles.editNamed": "Edit {name}",
  "users.roles.deleteNamed": "Delete {name}",
  "users.roles.deleteConfirm": "Delete role \"{name}\"?",
  "users.roles.empty": "No roles yet — create one to give it to team members",
  "users.roles.noPermissions": "No permissions given",
  "users.roles.updated": "Role updated",
  "users.roles.updateFailed": "The role could not be updated",
  "users.roles.savePermissions": "Save permissions",
  "users.roles.created": "Role created",
  "users.roles.createFailed": "The role could not be created",
  "users.roles.name": "Role name *",
  "users.roles.namePlaceholder": "Network engineer",
  "users.roles.description": "Description",
  "users.roles.descriptionPlaceholder": "Optional description",
  "users.roles.permissions": "Permissions",
  "users.roles.selected": { one: "{count} permission chosen", other: "{count} permissions chosen" },
  "users.roles.hoverHint": "Point at a permission to see what it allows",
  "users.group.sites": "Sites",
  "users.group.monitoring": "Monitoring",
  "users.group.templates": "Templates",
  "users.group.users": "Users",
  "users.group.vpn": "VPN",
  "users.group.company": "Company",
  "users.group.api": "API",
  "users.permission.SITE_VIEW": "View",
  "users.permission.SITE_CREATE": "Create",
  "users.permission.SITE_EDIT": "Edit",
  "users.permission.SITE_DELETE": "Delete",
  "users.permission.MONITORING_VIEW": "View",
  "users.permission.TEMPLATE_VIEW": "View",
  "users.permission.TEMPLATE_CREATE": "Create",
  "users.permission.TEMPLATE_EDIT": "Edit",
  "users.permission.TEMPLATE_DELETE": "Delete",
  "users.permission.TEMPLATE_APPLY": "Apply",
  "users.permission.USER_VIEW": "View",
  "users.permission.USER_CREATE": "Invite",
  "users.permission.USER_EDIT": "Edit",
  "users.permission.USER_DELETE": "Remove",
  "users.permission.VPN_ACCESS": "Access",
  "users.permission.VPN_VIEW": "View",
  "users.permission.VPN_MANAGE": "Manage",
  "users.permission.COMPANY_BRANDING": "Branding",
  "users.permission.COMPANY_SETTINGS": "Settings",
  "users.permission.LICENSE_VIEW": "View licence",
  "users.permission.LICENSE_MANAGE": "Manage licence",
  "users.permission.APIKEY_VIEW": "View",
  "users.permission.APIKEY_CREATE": "Create",
  "users.permission.APIKEY_DELETE": "Revoke",
  "users.permissionDesc.SITE_VIEW": "See the list of sites and their basic details",
  "users.permissionDesc.SITE_CREATE": "Add new sites",
  "users.permissionDesc.SITE_EDIT": "Change a site's settings and API key",
  "users.permissionDesc.SITE_DELETE": "Remove sites for good",
  "users.permissionDesc.MONITORING_VIEW": "See live data, devices and clients",
  "users.permissionDesc.TEMPLATE_VIEW": "Browse the template library",
  "users.permissionDesc.TEMPLATE_CREATE": "Build new templates",
  "users.permissionDesc.TEMPLATE_EDIT": "Change existing templates",
  "users.permissionDesc.TEMPLATE_DELETE": "Remove templates",
  "users.permissionDesc.TEMPLATE_APPLY": "Apply templates to sites",
  "users.permissionDesc.USER_VIEW": "See the list of team members",
  "users.permissionDesc.USER_CREATE": "Invite new members",
  "users.permissionDesc.USER_EDIT": "Change roles and status",
  "users.permissionDesc.USER_DELETE": "Remove members from the company",
  "users.permissionDesc.VPN_ACCESS": "The member gets a VPN account",
  "users.permissionDesc.VPN_VIEW": "See the VPN page and the state of the accounts",
  "users.permissionDesc.VPN_MANAGE": "Create, suspend and renew VPN accounts",
  "users.permissionDesc.COMPANY_BRANDING": "Change the logo, colours and look",
  "users.permissionDesc.COMPANY_SETTINGS": "Manage the company's settings and mail server",
  "users.permissionDesc.LICENSE_VIEW": "See the licence status and limits",
  "users.permissionDesc.LICENSE_MANAGE": "Renew and change the licence",
  "users.permissionDesc.APIKEY_VIEW": "See the list of API keys",
  "users.permissionDesc.APIKEY_CREATE": "Create new API keys",
  "users.permissionDesc.APIKEY_DELETE": "Revoke API keys",
  "users.group.rental": "Rental",
  "users.permission.RENTAL_VIEW": "View",
  "users.permission.RENTAL_PLAN": "Plan",
  "users.permission.STOCK_MANAGE": "Manage stock",
  "users.permission.PURCHASE_APPROVE": "Approve and send purchases",
  "users.permissionDesc.RENTAL_VIEW": "See stock, customers, events, planning and rental prices",
  "users.permissionDesc.RENTAL_PLAN": "Manage customers and events: lines, prices, discounts and status",
  "users.permissionDesc.STOCK_MANAGE": "Manage articles, items, cases, warehouses, transfers, suppliers, sub-rentals and purchase orders, and see costs",
  "users.permissionDesc.PURCHASE_APPROVE": "Approve purchase orders and sub-rental requests, which sends them to the supplier",
  "users.permission.MIKROTIK_PROVISION": "Provision MikroTik units",
  "users.permissionDesc.MIKROTIK_PROVISION": "Create or refresh a MikroTik site by its serial, issue its VPN certificate and receive its configuration",
  "users.permission.TELTONIKA_PROVISION": "Provision Teltonika routers",
  "users.permissionDesc.TELTONIKA_PROVISION": "Create or refresh a Teltonika site by its serial, issue its VPN certificate and receive its configuration",
  "users.permission.CLIENT_ACCOUNTS_MANAGE": "Manage client accounts",
  "users.permissionDesc.CLIENT_ACCOUNTS_MANAGE": "Invite, change and remove a customer's client people, and open \"View as client\" on an event. Only for members with access to all sites",
}

export default users
